import { useQuery } from "@tanstack/react-query";
import { orpc } from "./api";

export function useSystemInfo() {
  return useQuery({ ...orpc.system.info.queryOptions(), staleTime: Number.POSITIVE_INFINITY });
}
